/**
 * Schema Overview Feature Module
 *
 * Registers the schema-overview workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the schema-overview workspace component
registerWorkspaceComponent(
  'schema-overview',
  lazyWorkspaceTab(() => import('./components/SchemaOverviewTab').then((m) => ({ default: m.SchemaOverviewTab }))),
);

// This module is imported for its registration side effect only (see
// `workspace/index.ts`), so it deliberately re-exports NOTHING at runtime.
// `SchemaOverviewCanvas` and `DependencyGraphView` do `import
// '@xyflow/react/dist/style.css'`, which makes those modules side-effectful and
// therefore un-tree-shakeable: a value re-export from here dragged the whole
// @xyflow/react runtime back into the eager boot chunk even though every
// consumer lives behind the lazy `schema-overview` tab. Import from the
// concrete module path inside the feature instead.
export type {
  SchemaNode,
  SchemaEdge,
  SchemaNodeData,
  LayoutOptions,
  LayoutResult,
  LayoutAlgorithm,
} from './utils/schemaLayoutEngine';
export type { SchemaEdgeData } from './components/SchemaRelationshipEdge';
